import Vue from "vue";

import { ISettingsModel, IUserModel } from "@/models";
import { IValidationRules } from "@elite/validation";

import IAppState from "../IAppState";
import AppMutationTypes from "./AppMutationTypes";
import IAppMutationTree from "./IAppMutationTree";

const mutations: IAppMutationTree = {
    setSettings(state: IAppState, payload: ISettingsModel) {
        state.environmentAlert = payload.environmentAlert || "";
        state.roleItems = payload.roleItems || [];
        state.roleValues = payload.roleValues || {};
    },

    setValidationRules(state: IAppState, payload: IValidationRules) {
        // this makes the previously unset property reactive. see https://vuex.vuejs.org/guide/mutations.html#mutations-follow-vue-s-reactivity-rules
        Vue.set(state, "validationRules", payload);
    },

    setUser(state: IAppState, payload?: IUserModel) {
        Vue.set(state, "user", payload);
    },

    setToken(state: IAppState, payload?: string) {
        state.token = payload;
    }
};

export default mutations;

export { AppMutationTypes };
